import { createContext, useContext } from 'react';
export const DataSourceContext = /*#__PURE__*/createContext({
  index: -1
});
export const useDataSourceLocation = () => useContext(DataSourceContext);